import { IRbac } from '../../apis/__shared/rbac.interfaces';

export const mockRbacParent: IRbac = {
  dashboard: {
    finance: {
      read: true,
      write: false,
      delete: false,
    },
    people: {
      read: false,
      write: false,
      delete: false,
    },
    events: {
      read: true,
      write: false,
      delete: false,
    },
  },
  students: {
    studentList: {
      read: false,
      write: false,
      delete: false,
    },
    attendance: {
      read: true,
      write: false,
      delete: false,
    },
    fees: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: false,
      delete: false,
    },
    scores: {
      read: true,
      write: false,
      delete: false,
    },
    documents: {
      read: true,
      write: false,
      delete: false,
    },
  },
  staff: {
    staffList: {
      read: true,
      write: false,
      delete: false,
    },
    attendance: {
      read: false,
      write: false,
      delete: false,
    },
    payouts: {
      read: false,
      write: false,
      delete: false,
    },
    events: {
      read: true,
      write: false,
      delete: false,
    },
    documents: {
      read: false,
      write: false,
      delete: false,
    },
  },
  academics: {
    curriculum: {
      read: true,
      write: false,
      delete: false,
    },
    schedules: {
      read: true,
      write: false,
      delete: false,
    },
    lessonPlans: {
      read: true,
      write: false,
      delete: false,
    },
    materials: {
      read: true,
      write: false,
      delete: false,
    },
    assessments: {
      read: true,
      write: false,
      delete: false,
    },
    library: {
      read: true,
      write: false,
      delete: false,
    },
  },
  communications: {
    messaging: {
      read: true,
      write: true,
      delete: true,
    },
    announcements: {
      read: true,
      write: false,
      delete: false,
    },
    concerns: {
      read: true,
      write: true,
      delete: false,
    },
    events: {
      read: true,
      write: false,
      delete: false,
    },
    meetings: {
      read: true,
      write: false,
      delete: false,
    },
  },
  finance: {
    financeList: {
      read: true,
      write: false,
      delete: false,
    },
    scholarships: {
      read: true,
      write: false,
      delete: false,
    },
    financialReports: {
      read: false,
      write: false,
      delete: false,
    },
  },
  analytics: {
    performance: {
      read: true,
      write: false,
      delete: false,
    },
    customDashboards: {
      read: false,
      write: false,
      delete: false,
    },
  },
  administration: {
    transport: {
      read: true,
      write: false,
      delete: false,
    },
    inventory: {
      read: false,
      write: false,
      delete: false,
    },
    healthAndSafety: {
      read: true,
      write: false,
      delete: false,
    },
  },
  users: {
    parents: {
      read: false,
      write: false,
      delete: false,
    },
    visitors: {
      read: false,
      write: false,
      delete: false,
    },
    guests: {
      read: false,
      write: false,
      delete: false,
    },
  },
  settings: {
    userManagement: {
      read: false,
      write: false,
      delete: false,
    },
    complianceManagement: {
      read: false,
      write: false,
      delete: false,
    },
  },
  profile: {
    personalDetails: {
      read: true,
      write: true,
      delete: false,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
    calendar: {
      read: true,
      write: true,
      delete: true,
    },
    leaves: {
      read: true,
      write: false,
      delete: false,
    },
  },
  guardian: {
    dashboard: { read: true, write: false, delete: false },
    academicsSchedule: { read: true, write: false, delete: false },
    academicsCurriculum: { read: true, write: false, delete: false },
    academicsLessonPlans: { read: true, write: false, delete: false },
    academicsMaterials: { read: true, write: false, delete: false },
    academicsAssessments: { read: true, write: false, delete: false },
    academicsHomework: { read: true, write: false, delete: false },
    academicsAttendance: { read: true, write: false, delete: false },
    academicsLibrary: { read: true, write: false, delete: false },
    fees: { read: true, write: false, delete: false },
    transport: { read: true, write: false, delete: false },
    documents: { read: true, write: false, delete: false },
    eventsCommunication: { read: true, write: false, delete: false },
    concerns: { read: true, write: true, delete: false },
    profile: { read: true, write: true, delete: false },
    settings: { read: true, write: false, delete: false },
  },
};
